import Box from '@mui/material/Box'
import Typography, { type TypographyProps } from '@mui/material/Typography'

const TYPOGRAPHY_SX = {
    textAlign: 'center',
    width: '100%',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    whiteSpace: 'normal',
}

const WORD_BOX_BASE_SX = {
    display: 'inline',
    mx: 0.5,
}

interface ColorTitleProps extends Omit<TypographyProps, 'variant' | 'color'> {
    title?: string
    colorFrom?: number
    colorTo?: number
    variant?: TypographyProps['variant']
    color?: string
    [key: string]: any
}

const Index = ({ title = '', colorFrom = 0, colorTo = colorFrom + 1, variant, color, ...rest }: ColorTitleProps) => {
    const { variant: _, color: __, ...sxProps } = rest as any
    return (
        <Typography
            variant={(variant as TypographyProps['variant']) || 'h2'}
            color='white'
            sx={{ ...TYPOGRAPHY_SX, ...sxProps }}
        >
            {(() => {
                const words = title.split(' ')
                return words.map((word, index) => (
                    <Box
                        key={`${word}-${index}`}
                        component='span'
                        sx={{
                            ...WORD_BOX_BASE_SX,
                            color: (colorFrom < index && colorTo >= index) ? 'primary.light' : color || 'black',
                        }}
                    >
                        {word}
                        {index !== words.length - 1 ? ' ' : ''}
                    </Box>
                ))
            })()}
        </Typography>
    )
}

export default Index


